import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledTextArea = styled.div`
  .m-input-text-field-v3 {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
    width: 100%;

    label {
      position: absolute;
      top: ${toRem(2)};
      left: ${toRem(16)};
      padding-top: ${toRem(8)};
      line-height: ${toRem(12)};
    }

    textarea {
      min-height: ${toRem(80)};
      width: 100%;
      padding: ${toRem(22)} ${toRem(16)} ${toRem(10)};
      border: ${toRem(1)} solid ${baseVariables.color.neutral40};
      border-radius: ${toRem(8)};

      &::placeholder {
        color: ${baseVariables.color.neutral40};
      }

      &:hover:not(:disabled):not(:focus) {
        border-width: ${toRem(1.5)};
        border-color: ${baseVariables.color.base10};
        cursor: pointer;
      }

      &:focus {
        border-width: ${toRem(2)};
        border-color: ${baseVariables.color.base10};
        cursor: text;
      }

      &:disabled {
        background-color: ${baseVariables.color.neutral10};
        color: ${baseVariables.color.neutral40};
        cursor: not-allowed;
      }
    }

    .message {
      color: ${baseVariables.color.alert50};
      font-size: ${toRem(12)};
      line-height: ${toRem(20)};
    }

    &.is-inactive {
      label {
        background-color: ${baseVariables.color.neutral10};
      }

      textarea {
        background-color: ${baseVariables.color.neutral10};
        color: ${baseVariables.color.neutral40};
        cursor: default;

        &:hover,
        &:focus {
          border-width: ${toRem(1)};
          border-color: ${baseVariables.color.neutral40};
        }
      }
    }

    &.is-error {
      textarea {
        border-color: ${baseVariables.color.alert50};

        &:hover,
        &:focus {
          border-width: ${toRem(2)};
          border-color: ${baseVariables.color.alert50};
        }
      }
    }
  }
`;
